import React, { useEffect, useState } from 'react';
import TinySlider from "tiny-slider-react";
import './carousel.css';

export default function Carousel({ images }) {
  const [CarouselItem, setCarouselItem] = useState([]);
  const [Thumbnails, setThumbnails] = useState([]);
  const [popupImage, setPopupImage] = useState(null);

  const settings = {
    lazyload: true,
    mouseDrag: true,
    center: true,
    controls: true,
    controlsPosition: "bottom",
    controlsContainer: '.slider__arrows',
    nav: true,
    navPosition: "bottom",
    navAsThumbnails: true,
    navContainer: '.slider__thumbnails',
  };

  const openModal = (img) => {
    setPopupImage(img);
  };

  const closeModal = () => {
    setPopupImage(null);
  };

  useEffect(() => {
    setCarouselItem(() =>
      images.map((img, index) => (
        <div key={index} style={{ position: "relative" }} onClick={() => openModal(img)}>
          <img
            className="tns-lazy-img"
            data-src={img.url}
            alt={`garage ${index}`}
            src={img.url}
            style={{ transform: `rotate(${img.rotationAngle}deg)`, cursor: 'pointer' }}
          />
        </div>
      ))
    );

    setThumbnails(() =>
      images.map((img, index) => (
        <img
          key={index}
          className="thumbnail"
          src={img.url}
          alt={`thumbnail ${index}`}
          style={{ transform: `rotate(${img.rotationAngle}deg)` }}
        />
      ))
    );
  }, [images]);

  return (
    <>
      {CarouselItem.length > 0 && (
        <>
          <div className='slider__arrows'>
            <span className='arrow Left' id='prev'></span>
            <span className='arrow right' id='next'></span>
          </div>
          <TinySlider settings={settings}>
            {CarouselItem}
          </TinySlider>
          <div className='slider__thumbnails'>
            {Thumbnails}
          </div>
        </>
      )}

      {/* Modal */}
      {popupImage && (
        <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.6)" }} onClick={closeModal}>
          <div className="modal-dialog modal-lg modal-dialog-centered" role="document" onClick={e => e.stopPropagation()}>
            <div className="modal-content position-relative">
              <div className="modal-header">
                <h5 className="modal-title">Image Preview</h5>
                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                  <span aria-hidden="true"></span>
                </button>
              </div>


              <div className="modal-body text-center">
                <img
                  src={popupImage.url}
                  alt="Full Size"
                  className="img-fluid"
                  style={{ transform: `rotate(${popupImage.rotationAngle}deg)`, maxHeight: '80vh' }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
